export default {
  name: 'KTagGroup',
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  render() {
    const css = {
      'km-tag-group': true,
    }

    const data = { class: css }

    return (
      <div {...data}>
        {this.$slots.default}
      </div>
    )
  },
}
